import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MieDelegheDTO } from '../../models/mie-deleghe-dto';
import { Observable } from 'rxjs';
import { debounceTime, map, shareReplay } from 'rxjs/operators';
import { PersonaGiuridica } from '../../models/portale/persona-giuridica-model';
import { PersonaFisica } from '../../models/portale/persona-fisica-model';
import { ConfigurationService } from '../../../configuration/configuration-service';
import { PersonaGiuridicaDTO } from '../../models/persona-giuridica-dto';
import { NaturaRichiedenteRequestDTO } from '../../models/natura-richiedente-request.dto';
import { NaturaRichiedenteDTO } from '../../models/natura-richiedente.dto';
import { RtsDTO } from '../../models/rts-dto';

@Injectable({
	providedIn: 'root'
})
export class DelegheService {

	DELEGA_VALIDATA = 'TRUE';
	servicePaths: Map<string, string>;
	urlAnagrafe: string;
	urlDeleghe: string;
	urlAnagrafe2: string;
	urlDeposito: string;

	constructor(
		private http: HttpClient,
		private configurationService: ConfigurationService
	) {
		this.urlAnagrafe = this.configurationService.servicePaths.get("ANAGRAFE_MS_API_URL") + "/v1";
		this.urlAnagrafe2 = this.configurationService.servicePaths.get("ANAGRAFE_MS_API_URL") + "/v2";
		this.urlDeleghe = this.configurationService.servicePaths.get("DELEGHE_MS_API_URL") + "/v1";
		this.urlDeposito = configurationService.servicePaths.get("DEPOSITO_MS_API_URL") + "/v1";
	}

	getDatiSocieta(id: string): Observable<PersonaGiuridica> {
		// console.log('[getDatiSocieta - lib]', id);
		return this.http.put<PersonaGiuridica>(this.urlDeposito + `/supporto/personagiuridica/delega`, id);
	}

	getPersona(id: string): Observable<PersonaFisica> {
		// console.log('[getPersona - lib]', id);
		return this.http.get<PersonaFisica>(this.urlAnagrafe + `/personaFisica/${id}`);
		// return this.http.get<PersonaFisica>(this.urlAnagrafe + "/personaFisica/" + "{id}");
	}

	getMieDeleghe(): Observable<MieDelegheDTO> {

		return this.http.get<MieDelegheDTO>(this.urlDeleghe + `/deleghe/mie`)
			.pipe(map(deleghe => {
				const deleghePF = deleghe.personeFisiche ?
					deleghe.personeFisiche.filter(d => this.DELEGA_VALIDATA == d.validata)
					: [];

				const deleghePG = deleghe.personeGiuridiche ?
					deleghe.personeGiuridiche.filter(d => this.DELEGA_VALIDATA == d.validata)
					: [];

				const delegheValidate = new MieDelegheDTO();
				delegheValidate.personeFisiche = deleghePF;
				delegheValidate.personeGiuridiche = deleghePG;

				return delegheValidate;
			}));
	}

	getListaPfPaged(pageSize, pageNumber, data): Observable<PersonaFisica> {
		// return this.http.post(this.urlAnagrafe + `/personeFisiche?offset=0&pageNumber=${pageNumber}&pageSize=${pageSize}&paged=false&sort.sorted=false&sort.unsorted=false&unpaged=false`, data);
		return this.http.post<PersonaFisica>(this.urlAnagrafe + `/personeFisiche?offset=0&pageNumber=${pageNumber}&pageSize=${pageSize}&paged=false&sort.sorted=false&sort.unsorted=false&unpaged=false`, data);
	}

	//TODO
	getListaPg(paginationData, filtroRicercaPersonaPG: PersonaGiuridicaDTO) {
		return this.http.post(this.urlAnagrafe + `/personeGiuridiche`, filtroRicercaPersonaPG, { params: paginationData });
	}

	getListaPgPaged(pageSize, pageNumber, data) {
		return this.http.post(this.urlAnagrafe + `/personeGiuridiche?offset=0&pageNumber=${pageNumber}&pageSize=${pageSize}&paged=false&sort.sorted=false&sort.unsorted=false&unpaged=false`, data);
	}

	getPersonaGiuridicaCodiceFiscale(codiceFiscale: string): Observable<PersonaGiuridica> {
		// console.log('[getPersonaGiuridicaCodiceFiscale] - codiceFiscale', codiceFiscale);
		//TODO
		// const url: string = this.urlAnagrafe2 + `/personaGiuridica/codiceFiscale`;
		// SE_SI_TRATTA_DI_UNA_NUOVA_PG => SI_DEVE_CHIAMARE_LA_SEGUENTE_SERVIZIO
		const url: string = this.urlDeposito + `/supporto/personagiuridica`;

		// console.log('[getPersonaGiuridicaCodiceFiscale] - url', url);
		return this.http.put<PersonaGiuridica>(url, codiceFiscale);
	}

	getPersonaFiscaleCodiceFiscale(codiceFiscale: string): Observable<PersonaFisica> {
		// console.log('[getPersonaFiscaleCodiceFiscale] - codiceFiscale', codiceFiscale);
		const url: string = this.urlAnagrafe2 + `/personaFisica/codiceFiscale`;
		// console.log('[getPersonaFiscaleCodiceFiscale] - url', url);
		return this.http.put<PersonaFisica>(url, codiceFiscale);
	}

	getListRtsCodiceRegione(listaCodiceRegione: Array<string>): Observable<Array<RtsDTO>> {
		// console.log('[getListRtsCodiceRegione] - listaCodiceRegione', listaCodiceRegione);
		const url: string = this.urlDeposito + `/rtsdto`;
		// console.log('[getListRtsCodiceRegione] - url', url);
		return this.http.put<Array<RtsDTO>>(url, listaCodiceRegione);
	}

	naturaRichiedente(request: NaturaRichiedenteRequestDTO): Observable<Array<NaturaRichiedenteDTO>> {
		const url: string = this.urlDeposito + `/naturarichiedente`;
		// console.log('[naturaRichiedente] - url', url);
		// console.log('[naturaRichiedente] - request', request);
		return this.http.put<Array<NaturaRichiedenteDTO>>(url, request);
	}

	getValidaPersonaFisica(request): Observable<any> {
		console.log('[getValidaPersonaFisica] - request', request);
		const url: string = this.urlDeposito + `/supporto`;
		console.log('[getValidaPersonaFisica] - url', url);
		return this.http.put<any>(url, request);
	}
	getAllProvince(): Observable<any> {
		const url: string = this.urlAnagrafe + `/province/mappa/`;
		console.log('[MappaProvince] - url', url);
		return this.http.get<any>(url).pipe(shareReplay());
	}
}